import { defineStore } from 'pinia';
import { computed } from 'vue';
import { canAdminAi, useEntitlement } from '#layers/access/public';
import { useWorkspaceInfoStore } from '#layers/workspace/public';

/**
 * AI assistant availability. Single source of truth for whether the panel shows and,
 * when shown, whether it renders the chat or the setup CTA. Derives from workspace runtime
 * information plus AI entitlements. Live chat session state lives in `useChatStore`, not here.
 */
export const useAiStore = defineStore('ai', () => {
	const workspaceInfo = useWorkspaceInfoStore();
	const { can } = useEntitlement();

	const enabled = computed(() => workspaceInfo.aiEnabled);
	const loading = computed(() => workspaceInfo.loading);

	/**
	 * Panel + header-toggle visibility. Everyone sees it once AI is enabled; before
	 * that only those who can configure AI see it (with a setup CTA). A non-admin with no
	 * configured provider sees nothing.
	 */
	const showAiPanel = computed(() => enabled.value || can(canAdminAi));

	return { enabled, loading, showAiPanel };
});
